// common/src/actions/reservations.actions.js

import { SET_NEW_RESERVATIONS_COUNT } from '../store/types';

/**
 * Set number of new (unvisited) reservations
 */
export const setNewReservationsCount = (count) => ({
  type: SET_NEW_RESERVATIONS_COUNT,
  payload: count,
});

/**
 * Optional helper: reset badge
 */
export const resetNewReservationsCount = () => ({
  type: SET_NEW_RESERVATIONS_COUNT,
  payload: 0,
});
